/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { imagesGetSnsAccountImageApiV1ImagesLedgersLedgerCanisterIdAccountsIdPngGet } from "../../funcs/imagesGetSnsAccountImageApiV1ImagesLedgersLedgerCanisterIdAccountsIdPngGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetSnsAccountImageApiV1ImagesLedgersLedgerCanisterIdAccountsIdPngGetRequest$inboundSchema,
};

export const tool$imagesGetSnsAccountImageApiV1ImagesLedgersLedgerCanisterIdAccountsIdPngGet:
  ToolDefinition<typeof args> = {
    name:
      "sns-account-image-ledgers-ledger-canister-id-png-get",
    description: `Get open graph image for ICRC ledger account`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await imagesGetSnsAccountImageApiV1ImagesLedgersLedgerCanisterIdAccountsIdPngGet(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
